import { render, staticRenderFns } from "./AboutPart.vue?vue&type=template&id=ef718cf8&scoped=true&"
import script from "./AboutPart.vue?vue&type=script&lang=js&"
export * from "./AboutPart.vue?vue&type=script&lang=js&"
import style0 from "./AboutPart.vue?vue&type=style&index=0&id=ef718cf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef718cf8",
  null
  
)

export default component.exports